<!--  -->
<template>
  <div class="waea">
    <el-form
      v-loading="loading"
      :label-position="labelPosition"
      label-width="100px"
      element-loading-text="正在创建中"
      element-loading-spinner="el-icon-loading"
    >
      <el-form-item label="企业名称">
        <el-input
          v-model="corp_name"
          class="copwe_name"
        />
      </el-form-item>
      <el-form-item label="企业ID">
        <el-input
          v-model="corp_id"
          class="copwe_name"
        />
      </el-form-item>
      <el-form-item label="客服ID与名称">
        <el-input
          v-model="inputText"
          type="textarea"
          :autosize="{ minRows: 14, maxRows: 4 }"
          placeholder="请输入客服ID与名称（格式： 名称在上，ID在下）"
          style="width:500px;height:300px"
          @blur="extractData"
        />
        <div style="color: #F56C6C; font-size: 12px; margin-top: 20px; line-height: 1.7;">
          客服名称与ID格式示例：<br>
          余觅微阅6<br>
          wo7eXwDAAA_GFPDGtYjOJaH5vcV7lJEA<br>
          余觅微阅7<br>
          wo7eXwDAAAROZDE_9iMJa7uHuleeybqg
        </div>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbitr"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { wechatcorpcreate } from '@/api/dataReport.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      corp_name: '',
      corp_id: '',
      inputText: '',
      users: [], // 存储提取的名字和 ID 对象
      loading: false,
      originalString: 'internal/ad/adPassBack/addUserIdMapUserName',
      base64String: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(type) {
      this.base64String = btoa(this.originalString)
      console.log('type', type)
      console.log('base64String', this.base64String)
    },
    sumbitr() {
      if (this.corp_name === '') {
        this.$message.error('请输入企业名称')
        return
      }
      if (this.corp_id === '') {
        this.$message.error('请输入企业ID')
        return
      }
      if (this.inputText === '') {
        this.$message.error('请输入客服ID与名称')
        return
      }
      // wechatcorpcreate({ corp_name: this.corp_name, corp_id: this.corp_id, user_map: this.users }, this.base64String)
      //   .then(response => {
      //     console.log('请求成功:', response)
      //   })
      //   .catch(error => {
      //     console.error('请求失败:', error)
      //   })
      this.loading = true
      wechatcorpcreate({
        corp_name: this.corp_name,
        corp_id: this.corp_id,
        user_map: this.users,
        forward_url: this.base64String
      })
        .then(res => {
          console.log('res', res)
          this.$message({
            message: '创建成功',
            type: 'success'
          })
          // this.corp_name = ''
          // this.corp_id = ''
          // this.inputText = ''
          // this.users = []
          this.loading = false
          this.$emit('updatawe', this.corp_id)
        })
        .catch(err => {
          console.log('err', err)
          this.loading = false
        })
      console.log('users', this.users)
    },
    extractData() {
      const lines = this.inputText
        .split('\n')
        .map(line => line.trim())
        .filter(line => line)
      this.users = []

      for (let i = 0; i < lines.length; i += 2) {
        if (i + 1 < lines.length) {
          this.users.push({
            user_name: lines[i], // 偶数行是名字
            user_id: lines[i + 1] // 奇数行是 ID
          })
        }
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.waea {
  padding: 30px;
}
.copwe_name {
  width: 300px;
}
</style>
